<template>
  <HeaderBase>
    <div
      class="flex items-center header-title cursor-pointer"
      @click="$router.push({
        name: 'settings.admins',
      })">
      <span class="arrow arrow-l arrow-primary"></span>
      <span>
        <b>Администратор: </b>
        <b class="text-muted">{{ $delve(admin, 'name') }}</b>
      </span>
    </div>
    <div class="flex flex-row items-center">

    </div>
  </HeaderBase>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import HeaderBase from './HeaderBase.vue';

export default {
  components: {
    HeaderBase,
  },
  computed: {
    ...mapState({
      admins: (state) => state.settings.admins,
    }),
    id() {
      return _.get(this.$route, 'params.id');
    },
    admin() {
      return _.find(this.admins, (obj) => parseInt(obj.id, 10) === parseInt(this.id, 10)) || null;
    },
  },
};
</script>
